import { observer } from 'mobx-react-lite';

import GridContainer from '../components/container/GridContainer';

import Documents from '../views/documents/Documents';

const DocumentsPage = observer(
  (): JSX.Element => (
    <GridContainer>
      <Documents initialyShowDocs />
    </GridContainer>
  ),
);

export default DocumentsPage;
